

import React, { memo } from 'react';
import cx from 'classnames';
import { Text, Switch, Divider } from '../../../ui-kit';
import ExpirationDropdown from './ExpirationDropdown';
import PasswordInput from './PasswordInput';

import '../styles/_link-setting.scss';












function LinkSettings({
  isMobile,
  isPasswordSet,
  isExpirationSet,
  savedPassword,
  expiryDate,
  togglePassword,
  onSettingsChange,
  toggleExpiration
}) {
  return (
    <div className={cx('link-settings', { 'link-settings__small': isMobile })}>
      <div className="option-wrapper">
        <ExpirationDropdown
          isExpirationSet={isExpirationSet}
          expiryDate={expiryDate}
          onExpirationUpdate={onSettingsChange}
          toggleExpiration={toggleExpiration} />

      </div>
      <Divider />
      <div
        className={cx('option-wrapper', { 'option-wrapper__small': isMobile })}>

        <div className="link-settings__option">
          <div className="link-settings__option__content">
            <Text noMargin className="link-settings__option__title">
              Password Protect
            </Text>
            <Text noMargin className="link-settings__option__subtitle" autoGrow>
              Set a password to make your link more secure.
            </Text>
          </div>
          <Switch onChange={togglePassword} checked={isPasswordSet} />
        </div>
        {isPasswordSet &&
        <PasswordInput
          isMobile={isMobile}
          savedPassword={savedPassword}
          onPasswordUpdate={onSettingsChange} />}


      </div>
    </div>);

}

export default memo(LinkSettings);